import styled from "styled-components";

const CONTAINER_WIDTH = "80px";
const CONTAINER_HEIGHT = "32px";

export const Container = styled.div(({ theme }) => {
    return {
        width: CONTAINER_WIDTH,
        height: CONTAINER_HEIGHT,
        background: theme.colors[theme.colorMode].background_Secondary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: theme.spacing.xSmall,
        marginLeft: theme.spacing.xSmall,
    };
});
